module.exports = __webpack_public_path__ + "img/appAsset-brand--mercadopago.3a0909d1.svg";